module.exports = __webpack_public_path__ + "static/media/notebook.500d6aa7.png";